import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ORDENACAO_LOTE_PADRAO } from "../../constants/filtrosLote";
import {
  ABA_LOTES,
  ROTA_SOLICITACAO_PLACA,
} from "../../constants/navegacaoSolicitacaoPlaca";
import { TipoSolicitacaoPlaca } from "../../constants/tipoSolicitacaoPlaca";
import { useLotes } from "../../hooks/useLotes";
import {
  IEstadoAberturaLote,
  IEstadoListagemLotes,
  IEstadoVoltaSolicitacaoPlaca,
} from "../../interfaces/INavegacaoSolicitacaoPlaca";
import { FiltrosLotes } from "../FiltrosLotes";
import { ListarLotes } from "../ListarLotes";

interface IProps {
  tipo: TipoSolicitacaoPlaca;
  ativa: boolean;
  estadoInicial?: IEstadoListagemLotes;
}

export function LotesSolicitados({ tipo, ativa, estadoInicial }: IProps) {
  const navigate = useNavigate();
  const {
    lotes,
    totalRegistros,
    carregando,
    limite,
    reiniciarPaginacao,
    paginaInicial,
    aplicarFiltros,
    setPagina,
    mudarLimite,
    ordenar,
    recarregar,
    exportar,
    exportando,
    estado,
  } = useLotes(tipo, estadoInicial);

  useEffect(() => {
    if (ativa) recarregar();
  }, [ativa, recarregar]);

  // As duas navegações seguidas só valem porque o BrowserRouter navega de forma síncrona.
  function visualizarLote(id: number) {
    const volta: IEstadoVoltaSolicitacaoPlaca = {
      aba: ABA_LOTES,
      lotes: estado,
    };
    const abertura: IEstadoAberturaLote = { daAbaLotes: true };

    navigate(ROTA_SOLICITACAO_PLACA, { replace: true, state: volta });
    navigate(`${ROTA_SOLICITACAO_PLACA}/${id}`, { state: abertura });
  }

  return (
    <>
      <FiltrosLotes
        onBuscar={aplicarFiltros}
        valoresIniciais={estadoInicial?.filtros}
      />
      <ListarLotes
        lotes={lotes}
        totalRegistros={totalRegistros}
        carregando={carregando}
        limite={limite}
        reiniciarPaginacao={reiniciarPaginacao}
        onMudarPagina={setPagina}
        onMudarLimite={mudarLimite}
        onOrdenar={ordenar}
        onExportar={exportar}
        exportando={exportando}
        paginaInicial={paginaInicial}
        ordenacaoInicial={estadoInicial?.ordenacao ?? ORDENACAO_LOTE_PADRAO}
        onVisualizar={visualizarLote}
      />
    </>
  );
}
